import { EmptyState, EmptyStateSize } from '@pdcplan/shared/components';
import colorVarMap from '@pdcfrontendui/components/colors';
import { currentLanguage } from '../currentLanguage';
import { useFormatter } from '../hooks/useLang';

function NoStatusShiftsImage() {
  return (
    <svg
      width="221px"
      height="203px"
      viewBox="0 0 221 203"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g transform="translate(-0, 0)">
          <rect x="11.0213608" y="0" width="203" height="203"></rect>
          <path
            d="M165.232813,56.2670374 C183.922128,66.3768575 206.985537,71.24906 210.69689,82.8205408 C214.408244,94.5138267 198.767541,113.150001 193.067963,131.42076 C187.368384,149.691519 191.742479,167.596863 184.452321,177.341268 C177.162163,187.207478 158.207752,189.034554 142.434501,187.207478 C126.661249,185.502207 113.93661,180.26459 95.114747,181.117225 C76.4254325,181.848056 51.6388949,188.669139 34.2750637,182.700691 C17.0437809,176.732243 7.10265613,157.852459 10.4163644,140.79975 C13.7300726,123.868846 30.2986138,108.521409 38.7817069,89.3980141 C47.3973483,70.2746195 48.06009,47.2534629 59.8568913,34.2203213 C71.6536927,21.1871798 94.717102,18.0202482 113.406417,24.2323063 C132.095731,30.4443644 146.410951,46.0354123 165.232813,56.2670374 Z"
            fill={colorVarMap.colorPrimaryLightest}
            transform="translate(110.5214, 104.5) rotate(-7.3085) translate(-110.5214, -104.5)"
          ></path>
          <path
            d="M180.34419,59.3237338 C183.709623,61.3429934 186.305814,62.3526232 188.132763,62.3526232 C189.959712,62.3526232 192.700136,61.3429934 196.354034,59.3237338 C194.046309,63.2660978 192.892446,66.1507544 192.892446,67.9777035 C192.892446,69.8046527 194.046309,72.2566108 196.354034,75.3335778 C192.700136,73.3143182 189.959712,72.3046884 188.132763,72.3046884 C186.305814,72.3046884 183.709623,73.3143182 180.34419,75.3335778 C182.074984,71.487369 182.940381,68.6027125 182.940381,66.6796081 C182.940381,64.7565037 182.074984,62.3045456 180.34419,59.3237338 Z"
            fill={colorVarMap.colorPrimaryBaseDark}
            transform="translate(188.3491, 67.3287) rotate(14) translate(-188.3491, -67.3287)"
          ></path>
          <path
            d="M145.777765,21.7777649 C151.431044,25.1697326 155.792146,26.8657164 158.861069,26.8657164 C161.929992,26.8657164 166.533377,25.1697326 172.671223,21.7777649 C168.794688,28.400178 166.856421,33.2458461 166.856421,36.3147693 C166.856421,39.3836924 168.794688,43.5025103 172.671223,48.6712229 C166.533377,45.2792553 161.929992,43.5832714 158.861069,43.5832714 C155.792146,43.5832714 151.431044,45.2792553 145.777765,48.6712229 C148.685166,42.2103321 150.138866,37.364664 150.138866,34.1342186 C150.138866,30.9037732 148.685166,26.7849553 145.777765,21.7777649 Z"
            fill={colorVarMap.colorPrimaryBaseDark}
            transform="translate(159.2245, 35.2245) rotate(16) translate(-159.2245, -35.2245)"
          ></path>
          <g transform="translate(56, 57)">
            <circle
              fill="#EBF8F8"
              cx="53.8401863"
              cy="52.8401863"
              r="47.8401863"
            ></circle>
            <path
              d="M73.2638439,53 L68.9344736,53 C67.9929048,53 67.0974913,53.4523223 66.5436273,54.2277319 L52.0323905,74.3514572 L45.459871,65.2311634 C44.906007,64.4649848 44.0198246,64.0034315 43.0690248,64.0034315 L38.7396545,64.0034315 C38.1396351,64.0034315 37.7888546,64.6865304 38.1396351,65.175777 L49.6415442,81.1270602 C50.1928098,81.8964799 51.0812549,82.3528783 52.027775,82.3528783 C52.9742951,82.3528783 53.8627401,81.8964799 54.4140057,81.1270602 L73.8546322,54.1723455 C74.2146438,53.6830989 73.8638632,53 73.2638439,53 Z"
              fill={colorVarMap.colorPrimaryDark}
              fillRule="nonzero"
            ></path>
            <path
              d="M54,0 C83.8233765,0 108,24.1766235 108,54 C108,83.8233765 83.8233765,108 54,108 C24.1766235,108 0,83.8233765 0,54 C0,24.1766235 24.1766235,0 54,0 Z M54,10 C29.699471,10 10,29.699471 10,54 C10,78.300529 29.699471,98 54,98 C78.300529,98 98,78.300529 98,54 C98,29.699471 78.300529,10 54,10 Z"
              fill={colorVarMap.colorPrimaryDark}
              fillRule="nonzero"
            ></path>
          </g>
          <path
            d="M82.1001489,92.8338425 C83.4106392,96.5614119 86.6745803,99.054461 90.3345209,99.054461 C93.992658,99.054461 97.254231,96.5658883 98.566833,92.8420058 L100.7665,93.6173492 C99.1355675,98.2443435 95.0170327,101.386776 90.3345209,101.386776 C85.6493887,101.386776 81.5281347,98.238898 79.8998511,93.6073945 L82.1001489,92.8338425 Z"
            fill={colorVarMap.colorPrimaryDark}
            fillRule="nonzero"
            transform="translate(90.3332, 97.1103) scale(1, -1) translate(-90.3332, -97.1103)"
          ></path>
          <path
            d="M118.766816,92.8338425 C120.077306,96.5614119 123.341247,99.054461 127.001188,99.054461 C130.659325,99.054461 133.920898,96.5658883 135.2335,92.8420058 L137.433167,93.6173492 C135.802234,98.2443435 131.683699,101.386776 127.001188,101.386776 C122.316055,101.386776 118.194801,98.238898 116.566518,93.6073945 L118.766816,92.8338425 Z"
            fill={colorVarMap.colorPrimaryDark}
            fillRule="nonzero"
            transform="translate(126.9998, 97.1103) scale(1, -1) translate(-126.9998, -97.1103)"
          ></path>
        </g>
      </g>
    </svg>
  );
}

export default function NoStatusShifts({
  className,
  from,
  to,
}: {
  className?: string;
  from: Date;
  to: Date;
}) {
  const formatter = useFormatter();
  return (
    <EmptyState
      className={className}
      image={NoStatusShiftsImage}
      heading={currentLanguage.NoUnresolvedIssues}
      description={currentLanguage.NothingToTakeActionOn_2(
        formatter.dayDescription(from, false),
        formatter.dayDescription(to, true)
      )}
      size={EmptyStateSize.Large}
    />
  );
}
